export type Role = "owner" | "branch_manager" | "recruiter" | "carrier";

export interface BranchRef {
  id: number;
  name: string;
  code: string;
  timezone: string;
}

export interface ScopeRef {
  id: number;
  name: string;
}

export interface Me {
  id: number;
  /** Kirish logini (email yo'q, 2026-10-18) */
  username: string;
  first_name: string;
  last_name: string;
  full_name: string;
  display_name: string;
  initials: string;
  role: Role;
  branch: BranchRef | null;
  /** Ishlaydigan filiallar: menejer bir nechtasini boshqarishi mumkin (asosiy + qo'shimcha); owner -- bo'sh */
  scope_branches: ScopeRef[];
  /** Rahbar(lar)i: filial menejerlari, vergul bilan */
  manager_name: string | null;
  totp_enabled: boolean;
  /** Roli uchun 2FA majburiy (Settings -> Security) */
  twofa_required: boolean;
  /** Majburiy, lekin hali sozlanmagan: platforma o'rniga sozlash sahifasi */
  must_setup_2fa: boolean;
  must_change_password: boolean;
  timezone: string;
  language: "en" | "uz" | "ru";
  notification_settings: Record<string, boolean>;
  member_since: string;
  /** Amaldagi ruxsatlar (backend: accounts/access.py) */
  permissions: Permission[];
  version: number;
}

/**
 * Ruxsatlar (RBAC). Rol -- doira (filial, jamoa); ruxsat -- shu doirada nimalar ochiq. Owner -- hammasi;
 * filial menejeri uchun owner belgilaydi (Admin -> Users -> Ruxsatlar).
 */
export const PERMISSIONS = ["reports", "approvals", "budget", "pay", "users", "drivers_sensitive", "drivers_transfer", "drivers_archive", "carriers_edit"] as const;
export type Permission = (typeof PERMISSIONS)[number];

/** UI'da bo'lim va tugmani ko'rsatish uchun. Haqiqiy tekshiruv backend'da (bu faqat ko'rinish). */
export function can(me: Pick<Me, "role" | "permissions"> | null | undefined, perm: Permission): boolean {
  if (!me) return false;
  return me.role === "owner" || (me.permissions ?? []).includes(perm);
}

export const ROLE_LABEL: Record<Role, string> = {
  owner: "Owner",
  branch_manager: "Branch manager",
  recruiter: "Recruiter",
  carrier: "Carrier",
};

export const isManager = (role: Role) => role === "owner" || role === "branch_manager";
